// user-settings.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  selectedLanguage = '';
  selectedLocation = '';
  selectedBuilding = '';
  selectedKiosk = '';
  selectedRepresentative = '';
  private settingsAreSetSubject = new BehaviorSubject<boolean>(false);
  settingsAreSet$ = this.settingsAreSetSubject.asObservable();

  settingsLoaded$ = new ReplaySubject<boolean>(1); // Replays last value to new subscribers
  setSettings(data: any) {
    // console.log('🔥 setSettings called');
    this.selectedLanguage = data.selectedLanguage || '';
    this.selectedLocation = data.selectedLocation || '';
    this.selectedBuilding = data.selectedBuilding || '';
    this.selectedKiosk = data.selectedKiosk || '';
    this.selectedRepresentative = data.selectedRepresentative || '';
    this.settingsLoaded$.next(true);

    this.settingsAreSetSubject.next(true);
  }
}
